import React, { useState } from 'react';
import RootContext from "./RootContext";

import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import Alert, { AlertProps } from "@mui/material/Alert";

interface Props {
    children: React.ReactNode;

}
const RootProvider: React.FC<Props> = ({ children }) => {
    const [toastOpen, setToastOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [duration, setDuration] = useState<number | null>(null);
    const [severity, setSeverity] = useState<AlertProps['severity']>("success");

    const toastMessage = (message: string, severity: AlertProps['severity'] = "success", duration: number | null = 3000) => {
        setMessage(message);
        setSeverity(severity);
        setDuration(duration);
        setToastOpen(true);
    };

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setToastOpen(false);
    };

    return (
        <RootContext.Provider
            value={{
                toastMessage
            }}
        >
            {children}

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                autoHideDuration={2500}
                open={toastOpen}
                onClose={() => handleClose()}
                TransitionComponent={Slide}
            >
                <Alert variant="filled" onClose={handleClose} severity={severity} sx={{ textTransform:'capitalize'}}>
                    {message}
                </Alert>
            </Snackbar>
        </RootContext.Provider>
    )
}

export default RootProvider;